var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9517 16.4688C47.9888 17.5059 48.5938 18.8887 48.5938 20.3579V47.0635C48.5938 50.1748 46.0874 52.5947 43.0625 52.5947H20.9375C17.8262 52.5947 15.4062 50.1748 15.4062 47.0635V13.876C15.4062 10.8511 17.8262 8.34473 20.9375 8.34473H36.5806C38.0498 8.34473 39.4326 8.94971 40.4697 9.98682L46.9517 16.4688ZM43.0625 48.4463C43.7539 48.4463 44.4453 47.8413 44.3589 47.0635V22.1729H37.5312C35.9756 22.1729 34.7656 20.9629 34.7656 19.4072V12.5796H20.9375C20.1597 12.5796 19.5547 13.1846 19.5547 13.9624V47.1499C19.5547 47.8413 20.1597 48.4463 20.9375 48.4463H43.0625Z",
    fill: "#0C41C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.3ff82cbcff5e75e232fb1cd014b4821d.svg";
export { ForwardRef as ReactComponent };